<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="secondary" dark class="title" flat>
      <v-icon left>fas fa-boxes</v-icon>
      Small Group Resources
    </v-toolbar>
    <v-card-text>
      <v-row dense class="font-weight-bold">
        <v-col cols="12" md="7">TITLE</v-col>
        <v-col cols="12" md="3">AUTHOR(S)</v-col>
        <v-col cols="12" md="2" class="text-center">INFO</v-col>
      </v-row>
      <v-row dense v-for="item in getResources" :key="item.id" class="body-1 rowalt" align="center">
        <v-col cols="12" md="7">
          {{item.title}}
        </v-col>
        <v-col cols="12" md="3">
          {{item.author}}
        </v-col>
        <v-col cols="12" md="2" class="text-center">
          <v-btn icon @click="viewResource(item)">
            <v-icon>fas fa-info-circle</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- VIEW SPECIFIC RESOURCE INFORMATION -->
  </v-card>
</template>

<script>
export default {
  methods: {
    viewResource(item){
      this.$router.push(`/resourceDetail/${item.id}`)
    }
  },
  computed: {
    getResources(){
      return this.$store.getters.getResources
    }
  }
}
</script>

